import { Link } from 'react-router-dom';

interface FooterLink {
  to: string;
  label: string;
}

const PLATFORM_LINKS: FooterLink[] = [
  { to: '/platform', label: 'Platform overview' },
  { to: '/lighthouse', label: 'Agent Lighthouse' },
  { to: '/studio', label: 'Agent Studio' },
  { to: '/console', label: 'Agent Console' },
];

const SOLUTIONS_LINKS: FooterLink[] = [
  { to: '/claims', label: 'Claims' },
  { to: '/underwriting', label: 'Underwriting' },
  { to: '/trial', label: 'Discovery Trial' },
];

const COMPANY_LINKS: FooterLink[] = [
  { to: '/trust', label: 'Governance & Trust' },
  { to: '/about', label: 'About' },
  { to: '/careers', label: 'Careers' },
  { to: '/contact', label: 'Contact' },
];

const LEGAL_LINKS: FooterLink[] = [
  { to: '/privacy', label: 'Privacy Policy' },
  { to: '/terms', label: 'Terms of Service' },
];

export function Footer() {
  return (
    <footer className="border-t bg-secondary text-secondary-foreground">
      <div className="container mx-auto grid gap-8 px-4 py-12 sm:grid-cols-2 lg:grid-cols-5">
        <div>
          <h4 className="mb-4 font-mono text-xs font-semibold uppercase tracking-widest text-secondary-foreground/70">
            CriticalBridge.AI
          </h4>
          <p className="text-sm text-secondary-foreground/70">
            © {new Date().getFullYear()} CriticalBridge.AI
            <br />
            Agentic AI for insurance
          </p>
          <a
            href="https://partners.criticalbridge.ai"
            target="_blank"
            rel="noopener noreferrer"
            className="mt-3 inline-block text-sm text-secondary-foreground/70 hover:text-secondary-foreground"
          >
            Partner Portal
          </a>
        </div>
        <div>
          <h4 className="mb-4 font-mono text-xs font-semibold uppercase tracking-widest text-secondary-foreground/70">
            Platform
          </h4>
          <ul className="space-y-2 text-sm">
            {PLATFORM_LINKS.map((link) => (
              <li key={link.to}>
                <Link
                  to={link.to}
                  className="text-secondary-foreground/70 hover:text-secondary-foreground"
                >
                  {link.label}
                </Link>
              </li>
            ))}
          </ul>
        </div>
        <div>
          <h4 className="mb-4 font-mono text-xs font-semibold uppercase tracking-widest text-secondary-foreground/70">
            Solutions
          </h4>
          <ul className="space-y-2 text-sm">
            {SOLUTIONS_LINKS.map((link) => (
              <li key={link.to}>
                <Link
                  to={link.to}
                  className="text-secondary-foreground/70 hover:text-secondary-foreground"
                >
                  {link.label}
                </Link>
              </li>
            ))}
          </ul>
        </div>
        <div>
          <h4 className="mb-4 font-mono text-xs font-semibold uppercase tracking-widest text-secondary-foreground/70">
            Company
          </h4>
          <ul className="space-y-2 text-sm">
            {COMPANY_LINKS.map((link) => (
              <li key={link.to}>
                <Link
                  to={link.to}
                  className="text-secondary-foreground/70 hover:text-secondary-foreground"
                >
                  {link.label}
                </Link>
              </li>
            ))}
          </ul>
        </div>
        <div>
          <h4 className="mb-4 font-mono text-xs font-semibold uppercase tracking-widest text-secondary-foreground/70">
            Legal
          </h4>
          <ul className="space-y-2 text-sm">
            {LEGAL_LINKS.map((link) => (
              <li key={link.to}>
                <Link
                  to={link.to}
                  className="text-secondary-foreground/70 hover:text-secondary-foreground"
                >
                  {link.label}
                </Link>
              </li>
            ))}
          </ul>
        </div>
      </div>
    </footer>
  );
}
